import React from 'react';
import routes from '~/apiRouter';

import { onlineCityCode } from '~/data/fakeCities';

class NearestEvent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      eventIDs: [],
      nearestStartDate: '',
      nearestEndDate: '',
    };

    this.selfRef = React.createRef();
  }

  async getEventId() {
    const eventIDRaw = this.selfRef.current?.parentElement.getAttribute(
      'data-code',
    );

    const eventIDs = eventIDRaw
      ? JSON.parse(eventIDRaw.replace(/\'/g, '"'))
      : [];
    await this.setState({ eventIDs });
  }

  async componentDidMount() {
    try {
      await this.getEventId();
      if (this.state.eventIDs.length) await this.getNearestDate();
    } catch (e) {}
  }

  getNearestDate() {
    const { eventIDs } = this.state;

    // fetch dates
    const options = {
      method: 'GET',
      credentials: 'include',
      headers: {
        Accept: 'application/json',
      },
    };

    fetch(`${routes.playbill.get}${eventIDs.join('/')}`, options)
      .then(response => response.json())
      .then(json => {
        if (json.status === 'success') {
          const currentCityCode = Object.values(window.city).find(
            city => city.CURRENT,
          ).KLADR;

          const cards = [];
          const currentCity = Object.values(window.city).find(
            city => city.CURRENT,
          );

          json.data.EVENTS.filter(
            event =>
              !event.AVAILABILITY_IN_CITIES.length ||
              event.AVAILABILITY_IN_CITIES.includes(currentCity.KLADR),
          )
            .filter(
              event =>
                event?.CITY?.KLADR === currentCityCode ||
                event.CITY_CODE == onlineCityCode,
            )
            .forEach(e => {
              cards.push({
                dateFrom:
                  e.START_DATE != null ? new Date(e.START_DATE) : new Date(),
                productCard: e.START_DATE == null,
                ...e,
              });
            });

          const dates = cards
            .map(event => {
              return {
                date: event.dateFrom,
                productCard: event.productCard,
              };
            })
            .filter(e => e.date >= new Date());

          if (!dates?.length) throw new Error('No events fetched');

          dates.sort((a, b) => {
            return a.date - b.date;
          });
          const nearestEvent = dates[0];

          const nearestStartDate = nearestEvent.productCard
            ? 'В любое время'
            : `Ближайшая дата: ${new Date(nearestEvent.date).toLocaleDateString(
                'ru',
              )}`;
          // const nearestEvent = json.data.EVENTS.find(
          //   event =>
          //     new Date(event?.START_DATE).getTime() === nearestStartDateMs,
          // );
          const nearestEndDateMs = new Date(nearestEvent?.END_DATE).getTime();
          const nearestEndDate = new Date(nearestEndDateMs).toLocaleDateString(
            'ru',
          );
          this.setState({ nearestStartDate, nearestEndDate });
        }
      })
      .catch(() => {});
  }

  render() {
    const { nearestStartDate } = this.state;

    return nearestStartDate ? (
      <div className="checkin-mini__descr" ref={this.selfRef}>
        <svg>
          <use href="/static/img/icons/icons.svg#i-calendar"></use>
        </svg>
        <span>{nearestStartDate}</span>
      </div>
    ) : (
      <div ref={this.selfRef}></div>
    );
  }
}

export default NearestEvent;
